import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search-iconic",
  "use": "icon-search-iconic-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-search-iconic\"><path d=\"M991 990q-10 9-22.5 9t-21.5-8L680 723q-79 68-181 88-99 19-195-11-99-32-170-108.5T39 514q-23-98 4-196 28-100 101.5-173.5T318 43q98-27 196-4 101 24 177.5 95T800 304q30 96 11 195-20 102-88 181l268 267q8 9 8 21.5t-8 21.5zM424 91q-90 0-168 45-75 45-120 120-45 78-45 168.5T136 592q45 76 120 120 78 46 168.5 46T592 712q76-44 120-120 46-77 46-167.5T712 256q-44-75-120-120-77-45-168-45z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/search-iconic.svg
// module id = 1135
// module chunks = 2